import script from "./BaseChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChart.vue?vue&type=script&setup=true&lang=js"

import "./BaseChart.vue?vue&type=style&index=0&id=ea03e674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea03e674"]])

export default __exports__